module.exports = __webpack_public_path__ + "static/media/device-icons.43b81f9f40b1536357704a125c871c6c11d10d073792ce3ae8124484402e556f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/device-icons.woff
// module id = 2361
// module chunks = 204